import { c as _c } from "react/compiler-runtime";
import Errors, { type ErrorMessage } from 'indexed-db/errors';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { useMessageContext } from '@/components/Messages';
type ErrorMessageType = (typeof Errors)[keyof typeof Errors];
export function useGetTranslatedErrorMessage() {
  const $ = _c(2);
  const t = useTranslations("nextjs.donation_feed.errors");
  let t0;
  if ($[0] !== t) {
    t0 = (message, retry) => {
      switch (message) {
        case Errors.FetchError:
          {
            return t("fetch_error_with_retry", {
              count: retry ?? 0
            });
          }
        case Errors.FatalFetchError:
          {
            return t("fatal_fetch_error");
          }
        case Errors.DataError:
          {
            return t("data_error");
          }
        case Errors.MigrationError:
          {
            return t("migration_error");
          }
        case Errors.UnknownDexieError:
          {
            return t("unknown_dexie_error");
          }
        default:
          {
            return t("unknown_error", {
              message
            });
          }
      }
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getMessageTranslation = t0;
  return getMessageTranslation;
}
function useHandleDbError() {
  const $ = _c(4);
  const {
    addMessage,
    removeMessage
  } = useMessageContext();
  const t = useGetTranslatedErrorMessage();
  let t0;
  if ($[0] !== addMessage || $[1] !== removeMessage || $[2] !== t) {
    t0 = errorMessage => {
      if (errorMessage.action === "success") {
        removeMessage("donation-feed-error");
        return;
      }
      if (errorMessage.action !== "error") {
        return;
      }
      const translatedMessage = t(errorMessage.message, errorMessage.retry);
      addMessage({
        id: "donation-feed-error",
        message: translatedMessage,
        type: "error",
        dismissible: true
      });
      console.error({
        message: errorMessage.message,
        originalErrorMessage: errorMessage.originalErrorMessage
      });
    };
    $[0] = addMessage;
    $[1] = removeMessage;
    $[2] = t;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleDbError = t0;
  return handleDbError;
}
export default useHandleDbError;